import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useCreateTVShow } from '@/hooks/useTVShows';
import { CreateTVShowRequest } from '@/types/model';
import TVShowForm from '@/components/forms/TVShowForm';
import Button from '@/components/ui/Button';

const CreateTVShow = () => {
  const navigate = useNavigate();
  const createTVShowMutation = useCreateTVShow();

  const handleCreateTVShow = async (data: CreateTVShowRequest) => {
    try {
      const response = await createTVShowMutation.mutateAsync(data);
      navigate({pathname: `/content/tv-shows/${response.tvShow?.id}/episodes`});
    } catch (error) {
      console.error('Error creating TV show:', error);
      throw error;
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-4">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Button
            variant="link"
            onClick={handleCancel}
            className="mb-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver a Series
          </Button>

        <TVShowForm
          onSuccess={handleCreateTVShow}
          onCancel={handleCancel}
          isSubmitting={createTVShowMutation.isPending}
        />
      </div>
    </div>
  );
};

export default CreateTVShow;
